import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import RegisterForm from './components/auth/RegisterForm';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './api/AuthContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>

      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <AuthProvider>
          <App />
        </AuthProvider>
      </div>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
